import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-filter"
export default class extends Controller {
  static targets = ["query", "list", "language", "assessment", "category"]

  connect() {
    const selectedAssessmentType = this.assessmentTarget.value
    this.toggleCategoryFilter(selectedAssessmentType)
  }

  apply_filter() {
    const frame = this.listTarget
    const searchQuery = this.queryTarget
    const selectedAssessmentType = this.assessmentTarget.value || ""
    const language = this.languageTarget

    let endpoint = new URL(window.location.href)
    endpoint.searchParams.set("query", searchQuery.value)
    endpoint.searchParams.set("step", "assignment")
    endpoint.searchParams.set("filter", selectedAssessmentType)
    endpoint.searchParams.set("category", this.categoryTarget.value)

    endpoint.searchParams.set(
      "language",
      language.options[language.selectedIndex].value,
    )

    this.toggleCategoryFilter(selectedAssessmentType)

    frame.src = endpoint.toString()
  }

  toggleCategoryFilter(selectedAssessment) {
    const categoryFilter = this.categoryTarget
    if (selectedAssessment.includes("assessment")) {
      categoryFilter.classList.remove("hidden")
    } else {
      categoryFilter.classList.add("hidden")
    }
  }
}
